import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import { Visualisation } from "../components/visualization/visualization";
import { Header } from "../components/header/header";
import { Footer } from "../components/footer/footer";
import { getHeaderHeight } from "../utils/dom";
import state from "../state/state";
import { Frag } from "../components/frag/frag";
import { cleanString } from "oj-utils";
import { pause } from "oj-promise-utils";
import { FinalizeConfiguration } from "../components/finalizeConfiguration/finalizeConfiguration";
import "./variables.scss";
import "./reset.scss";
import "./typography.scss";
import "./index.scss";
class DelayRemoval extends MithrilTsxComponent {
    view(v) {
        return v.children;
    }
    onbeforeremove(v) {
        return pause(v.attrs.duration).promise;
    }
}
class Configure extends MithrilTsxComponent {
    hh;
    step = 0;
    stepClassName = 0;
    oninit(v) {
        const step = v.attrs.page === "finalize" ? 1 : 0;
        this.step = step;
        this.stepClassName = step;
    }
    handlePopstate = () => {
        const step = window.location.hash.startsWith("#/finalize") ? 1 : 0;
        this.applyStep(step);
    };
    view() {
        return m("div", { className: "oj-App", style: { "--header-height": (this.hh ?? 116) + "px" } },
            m("div", { className: cleanString("configurator", `page-${this.stepClassName}`) },
                m(Header, { step: this.step, onstep: async (step) => {
                        this.setStep(step === "next" ? this.step + 1 : step);
                    } }),
                m("div", null, this.step === 0
                    ? m(DelayRemoval, { key: 0, duration: 300 },
                        m(Visualisation, null))
                    : this.step === 1
                        ? m(DelayRemoval, { key: 1, duration: 300 },
                            m(FinalizeConfiguration, { step: this.step, onstep: async (step) => {
                                    this.setStep(step);
                                } }))
                        : m(Frag, { key: -1 })),
                m(Footer, { step: this.step, onstep: async (step) => {
                        this.setStep(step);
                    } })));
    }
    oncreate(v) {
        this.hh = getHeaderHeight();
        const ro = new ResizeObserver(() => {
            const hh = getHeaderHeight();
            if (this.hh !== hh) {
                this.hh = hh;
                m.redraw();
            }
        });
        const headerEl = document.body.querySelector("header.header");
        if (headerEl)
            ro.observe(headerEl);
        else
            ro.observe(document.body);
        state.on("*", m.redraw);
        state.on("navigate:finalize", () => this.setStep(1));
        window.addEventListener("popstate", this.handlePopstate);
    }
    onremove(_v) {
        window.removeEventListener("popstate", this.handlePopstate);
    }
    async setStep(step) {
        history.pushState({ step }, "", `${window.location.pathname}${window.location.search}#/${step === 0 ? "" : "finalize"}`);
        this.applyStep(step);
    }
    async applyStep(step) {
        this.step = step;
        m.redraw.sync();
        const renderEl = document.querySelector(".Visualization .render-container");
        renderEl.style.setProperty("--speed", "200ms");
        await pause(50).promise;
        this.stepClassName = step;
        m.redraw.sync();
    }
}
const root = document.getElementById("oj_root");
m.route.prefix = "#";
m.route(root, "/", {
    "/": Configure,
    // "/pdf": {
    //   onmatch: async () => {
    //     root
    //     const mod = await import("../components/pdf/pdf")
    //     let pdfParams = new URLSearchParams(location.search)
    //     let param = pdfParams.get("pdf")
    //     if (true || !param) {
    //       const articles: { artCodeTSNL: string, name: string, quantity: number, price: number }[] = []
    //       for (const artCodeTSNL in state.articles) {
    //         const a = state.articles[artCodeTSNL]
    //         if (a.quantity > 0) {
    //           try {
    //             const details = await getProductDetails(artCodeTSNL)
    //             const name = getProductName({}, details)
    //             const price = details?.price ?? 0
    //             articles.push({
    //               artCodeTSNL,
    //               quantity: a.quantity,
    //               name,
    //               price,
    //             })
    //           }
    //           catch {
    //             // ignore error          }
    //           }
    //         }
    //       }
    //       param = btoa(JSON.stringify({
    //         url: state.getURL(),
    //         wissel: {
    //           type: state.wissel.type.value,
    //           wisselLigger: state.wissel.wisselLigger.value,
    //           hoekVerhouding: state.wissel.hoekVerhouding.value,
    //           spoorStaafProfiel: state.wissel.spoorStaafProfiel.value,
    //           boogStraal: state.wissel.boogStraal.value,
    //         },
    //         articles,
    //       }))
    //       pdfParams.set("pdf", param)
    //       const newUrl = `${window.location.pathname}?${pdfParams.toString()}#pdf`
    //       history.replaceState(null, "", newUrl)
    //     }
    //     return mod.PDF
    //   },
    //   render: (v) => {
    //     return v
    //   },
    // },
    "/:page": Configure,
});
